export type ApiFetch = (path: string, init?: RequestInit) => Promise<Response>;

export type ReadJson = <T>(res: Response) => Promise<T>;

export type ReadErrorMessage = (res: Response) => Promise<string>;

export interface FileReviewApiClient {
  apiFetch: ApiFetch;
  readJson: ReadJson;
  readErrorMessage: ReadErrorMessage;
}

let client: FileReviewApiClient | null = null;

export function configureFileReviewApi(next: FileReviewApiClient): void {
  client = next;
}

export function getFileReviewApiClient(): FileReviewApiClient {
  if (!client) {
    throw new Error(
      'File review API is not configured. Call configureFileReviewApi() from your app bootstrap.'
    );
  }
  return client;
}
